<template>
	<div class="dataBlock">
		<v-date-picker
				width="100%"
				class="datePicker calendarDate"
				color="green"
				prev-icon="mdi-menu-left"
				next-icon="mdi-menu-right"
				:value="dateValue"
				no-title
		>
		</v-date-picker>
	</div>
</template>

<script>
import getDefaultDate from "@/helper/getDefaultDate";

export default {
	name: "DateBlock",
	data: () => ({
		dateValue: getDefaultDate(),
	})
};
</script>
